import React, { useCallback, useEffect, useState } from 'react';

import {
  Button, DialogActions,
  DialogContent, Grid, Typography
} from '@mui/material';
import styled from 'styled-components';

import sanitizeHtml from 'sanitize-html';
import { translate } from 'utils/helpers';
import { CookiesHelper } from 'utils/helpers/CookiesHelper';

const StyledDialogContent = styled(DialogContent)`
  max-width: 800px;
  min-height: 245px;
`;

export const CookiesModal = ({
  onClose
}) => {
  const breakpoint = 600;
  const [justify, setJustify] = useState(window.innerWidth < breakpoint ? 'center' : 'space-between');

  useEffect(() => {
    window.addEventListener('resize', () => {
      if (window.innerWidth < breakpoint) {
        setJustify('center');
      } else {
        setJustify('space-between');
      }
    });
  }, []);

  const handleCloseWithoutAction = useCallback(() => {
    CookiesHelper.setGACookie(false);
    onClose();
  }, [onClose]);

  const handleCancel = useCallback(() => {
    CookiesHelper.setGACookie(false);
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    CookiesHelper.setGACookie(true);
    onClose();
  }, [onClose]);

  return (
    <>
      <HeaderModal onClose={handleCloseWithoutAction}>
        <Typography style={{ fontSize: '2.0rem' }}>
          {translate('commons.rgpd.cookies.welcome', { applicationName: 'Databilan' })}
        </Typography>
      </HeaderModal>
      <StyledDialogContent>
        <Grid container spacing={1} style={{ marginTop: 5 }}>
          <Grid item sm={6} xs={12}>
            <img alt="tecnea_welcome" src={`${process.env.PUBLIC_URL}/assets/images/tecnea-welcome.png`} width="100%" />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('common.rgpd.cookies.popupIntro')) }}
              style={{ marginBottom: 20, fontSize: '1.7rem' }}
            />
          </Grid>
        </Grid>
        <Typography
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('common.rgpd.cookies.defaultAction')) }}
          style={{ marginTop: 10, fontSize: '1.7rem' }}
        />
        <Typography
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('common.rgpd.cookies.howToChange')) }}
          style={{ marginTop: 10, fontSize: '1.7rem' }}
        />
      </StyledDialogContent>
      <DialogActions>
        <Grid container justifyContent={justify} spacing={1} style={{ margin: 20 }}>
          <Grid item />
          <Grid item>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item>
                <Button
                  color="default"
                  id="cancel"
                  variant="contained"
                  onClick={handleCancel}
                >
                  {translate('button.refuse')}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  id="confirm"
                  variant="contained"
                  onClick={handleConfirm}
                >
                  {translate('button.accept')}
                </Button>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </DialogActions>
    </>
  );
};
